// Georgisches Wörterbuch — `Dict` erzwingt Vollständigkeit.
import type { Dict } from "./de";

export const ka: Dict = {
  meta: {
    title: "Pulpo: ციფრული მენიუ თქვენი რესტორნისთვის",
    description:
      "სტუმრები ასკანერებენ QR-კოდს მაგიდაზე და ხედავენ თქვენს მენიუს ტელეფონში: საკუთარ ენაზე, ფოტოებითა და მიმდინარე ფასებით.",
  },
  nav: { login: "შესვლა" },
  hero: {
    eyebrow: "ციფრული მენიუ თქვენი რესტორნისთვის",
    title: "თქვენი მენიუ. ნებისმიერ ენაზე. ყოველთვის განახლებული.",
    sub: "სტუმრები ასკანერებენ QR-კოდს მაგიდაზე და ხედავენ თქვენს მენიუს ტელეფონში: საკუთარ ენაზე, ფოტოებითა და მიმდინარე ფასებით. თქვენ კი ყველაფერს ერთ ადგილას მართავთ.",
    ctaStart: "დაიწყეთ უფასოდ",
    ctaDemo: "ნახეთ სანიმუშო მენიუ",
  },
  steps: {
    title: "როგორ მუშაობს",
    items: [
      {
        title: "დარეგისტრირდით და შეიყვანეთ კერძები",
        body: "კატეგორიები, ფასები, ფოტოები. პირდაპირ ბრაუზერში, ინსტალაციის გარეშე.",
      },
      {
        title: "QR-კოდი მაგიდაზე",
        body: "დაბეჭდეთ კოდი და მზადაა. სტუმრებს აპლიკაცია არ სჭირდებათ.",
      },
      {
        title: "შეცვალეთ, როცა რამე იცვლება",
        body: "ახალი ფასი, დღის კერძი: ონლაინ წამებში, ხელახალი ბეჭდვის გარეშე.",
      },
    ],
  },
  included: {
    title: "ყველაფერი შედის",
    hint: "რას შეუძლია თქვენს მენიუს, დამატებითი გადასახადის გარეშე.",
    price: "შედის",
    items: [
      {
        name: "მენიუ რამდენიმე ენაზე",
        note: "ავტომატური თარგმანით მსოფლიოს ნებისმიერი სტუმრისთვის",
      },
      {
        name: "ფოტოები, ალერგენები და აღნიშვნები",
        note: "ყველა კერძი სურათითა და მკაფიო დეკლარაციით",
      },
      {
        name: "ფასების შეცვლა წამებში",
        note: "სტამბისა და სტიკერების გარეშე",
      },
      {
        name: "დასაბეჭდი QR-კოდი",
        note: "მაგიდისთვის, კარისთვის ან ფლაერისთვის",
      },
      {
        name: "საკუთარი საიტი და დომენი",
        note: "თქვენი მენიუ თქვენი სახელით ცხოვრობს",
      },
      {
        name: "სტუმრებს აპლიკაცია არ სჭირდებათ",
        note: "დაასკანერეს, წაიკითხეს, შეუკვეთეს, როგორც ყოველთვის",
      },
    ],
  },
  pricing: {
    title: "ანგარიში, თუ შეიძლება",
    hint: "ციფრული მენიუ უფასოა.",
    lines: [
      { name: "ციფრული მენიუ", price: "0 €" },
      { name: "სტანდარტული ვებგვერდი მენიუთი და კონტაქტით", price: "0 €" },
      { name: "საკუთარი დომენის დაკავშირება", price: "0 €" },
      { name: "რეკლამა", price: "არა" },
    ],
    totalLabel: "სულ თვეში",
    total: "0 €",
    note: "შექმენით რესტორანი და მენიუ ონლაინაა. მადლობა სტუმრობისთვის!",
    extrasTitle: "სურვილისამებრ",
    extras: [
      { name: "მხარდაჭერა ჩატით და ელფოსტით", price: "9 € / თვეში" },
      { name: "ინდივიდუალური ვებგვერდი, ჩვენგან შექმნილი", price: "ერთჯერადად, 490 €-დან" },
    ],
  },
  finale: {
    title: "ონლაინ უკვე ამ საღამოს?",
    sub: "შექმენით რესტორანი, შეიყვანეთ კერძები და მენიუ მაშინვე ხელმისაწვდომია თქვენს საკუთარ მისამართზე.",
    cta: "დაიწყეთ უფასოდ",
  },
  phone: {
    restaurant: "Casa Pulpo",
    menuTitle: "მენიუ",
    category: "რჩეული",
    dishes: [
      { name: "დღის წვნიანი", price: "6,50 €" },
      { name: "შემწვარი რვაფეხა", price: "18,90 €" },
      { name: "შოკოლადის ტორტი", price: "7,20 €" },
    ],
  },
};
